
      /* disables react devtools */
      if (!window.location.port && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () { }
      }
    